import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Panel, PanelExplanation } from 'eone-ui/panels/panel';
import { SelectTableColumnsModal } from 'eone-ui/tables/select-table-columns-modal';
import { useState } from 'react';
import { MasterDetailTable } from './table';

interface SCMasterDetailTablePanelProps {
  children?: React.ReactNode;
  TableState?: any;
  DataTestId?: any;
  Title?: string;
  BodyHeight?: number;
  Explanation?: string;
  Loading?: boolean;
  Visible?: boolean;
  Search?: boolean;
  Collapsible?: boolean;
  Collapsed?: boolean;
  ShowSelectColumns?: boolean;
  ChildPadding?: boolean;
  SelectedRowId?: any;
  Icon?: IconDefinition;
  HideTableHeader?: boolean;
  EmptyMessage?: string;
  EmptyIcon?: IconDefinition;
  EmptyTitle?: string;
  EmptyPrompts?: { Label: string; OnClick: () => void }[];
  HorizontalScroll?: boolean;
  HeaderButtons?: { Label: string; Icon?: IconDefinition; OnClick: () => void }[];
  IdField?: string;
  SubRowsField?: string;
  Columns?: any[]; // TODO
  Rows?: any[]; // todo
  SelectedColumns?: any[]; // TODO;
  RowButtons?: any[]; // TODO;
  Locale?: any; // TODO
  Style?: any; // TODO
  IconType?: any; // TODO
  IconStyle?: any; // TODO
  TableStyle?: any; // TODO

  // testing
  IdFields: string[];
  SubRowFields: string[];
  ColumnsTest: any[][];
  RowButtonsTest?: any[][];
  HasSubRows?: boolean;
  GetSubRows?: (row: any, id: any) => void;

  SelectRow?: (id: any) => void;
  OnCollapse?: (value: any) => void;
  ChangeValue?: (id: any, fieldName: string, value: any) => void;
  UpdateValue?: (id: any, fieldName: string, value: any) => void;
}

//export function SCMasterDetailTablePanel(props: SCMasterDetailTablePanelProps) {
//	return (
//		<table style={{ backgroundColor: "red", width: '100%' }} >
//			<thead>
//				<th>Person 1</th>
//				<th>Person 2</th>
//				<th>Person 3</th>
//			</thead>
//			<tbody>
//				<tr>
//					<td>Emil</td>
//					<td>Tobias</td>
//					<td>Linus</td>
//				</tr>
//				<tr>
//					<td>16</td>
//					<td>14</td>
//					<td>10</td>
//				</tr>
//				<tr>
//					<td colSpan={3}>
//						<table style={{ backgroundColor: "green", width: '100%', paddingLeft: 30 }} >
//							<thead>
//								<th>Person 1</th>
//								<th>Person 2</th>
//								<th>Person 3</th>
//							</thead>

//							<tbody >
//								<tr>
//									<td>16</td>
//									<td>14</td>
//									<td>10</td>
//								</tr>
//							</tbody>
//						</table>
//					</td>
//				</tr>
//			</tbody>
//		</table>
//	)
//}

function SCMasterDetailTablePanel(props: SCMasterDetailTablePanelProps) {
  const [selectTableColumnsModal, setSelectTableColumnsModal] = useState({ Show: false });

  const collapseHandler = (value) => {
    if (typeof props.OnCollapse === 'function') {
      props.OnCollapse(value);
    }
  };

  const changeValue = (id: any, fieldName: string, value: any) => {
    if (typeof props.ChangeValue === 'function') {
      props.ChangeValue(id, fieldName, value);
    }
  };

  const updateValue = (id: any, fieldName: string, value: any) => {
    if (typeof props.UpdateValue === 'function') {
      props.UpdateValue(id, fieldName, value);
    }
  };

  const showSelectColumnsModal = () => {
    setSelectTableColumnsModal({ Show: true });
  };

  const selectColumns = (selectedColumns) => {
    props.TableState?.SetColumns(selectedColumns);
    setSelectTableColumnsModal({ Show: false });
  };

  const closeSelectColumnsModal = () => {
    setSelectTableColumnsModal({ Show: false });
  };

  return (
    <Panel
      Icon={props.Icon}
      IconType={props.IconType}
      IconStyle={props.IconStyle}
      Title={props.Title}
      BodyClass="eone-ui-panel-table-content"
      HeaderButtons={props.HeaderButtons}
      BodyHeight={props.BodyHeight}
      Visible={props.Visible}
      Search={props.Search && !props.Loading && props.Rows && props.Rows.length > 0}
      SearchValue={props.TableState?.Search}
      OnSearch={props.TableState?.SetSearch}
      Collapsible={props.Collapsible}
      Collapsed={props.Collapsed}
      OnCollapse={collapseHandler}
      ShowSelectTableColumns={
        props.ShowSelectColumns && !props.Loading && props.Rows && props.Rows.length > 0
      }
      SelectTableColumns={showSelectColumnsModal}
      Style={props.Style}
      DataTestId={props.DataTestId}
    >
      {props.children}

      <PanelExplanation Explanation={props.Explanation} />

      <MasterDetailTable
        Loading={props.Loading}
        IdFields={props.IdFields}
        SubRowFields={props.SubRowFields}
        ColumnsTest={props.ColumnsTest}
        Depth={0}
        RowButtonsTest={props.RowButtonsTest}
        Columns={props.Columns}
        HideTableHeader={props.HideTableHeader}
        SelectedColumns={props.SelectedColumns}
        HorizontalScroll={props.HorizontalScroll}
        Rows={props.Rows}
        Buttons={props.RowButtons}
        IdField={props.IdField}
        SubRowsField={props.SubRowsField}
        Locale={props.Locale}
        //Reorderable={props.Reorderable}
        //Reorder={reorderHandler}
        TableState={props.TableState}
        Style={props.TableStyle}
        EmptyMessage={props.EmptyMessage}
        EmptyIcon={props.EmptyIcon}
        EmptyTitle={props.EmptyTitle}
        EmptyPrompts={props.EmptyPrompts}
        ChangeValue={changeValue}
        UpdateValue={updateValue}
        ShowSelectColumns={props.ShowSelectColumns}
        BodyHeight={props.BodyHeight}
        SelectedRowId={props.SelectedRowId}
        SelectRow={props.SelectRow}
        ChildPadding={props.ChildPadding}
        DataTestId={props.DataTestId}
        HasSubRows={props.HasSubRows}
        GetSubRows={props.GetSubRows}
      />

      {props.Columns && props.Columns.length > 0 && (
        <SelectTableColumnsModal
          Show={selectTableColumnsModal.Show}
          Columns={props.Columns}
          SelectedColumns={props.TableState?.Columns}
          Select={selectColumns}
          Close={closeSelectColumnsModal}
        />
      )}
    </Panel>
  );
}

export { SCMasterDetailTablePanel };
